/**
 * @file index.ts
 * @summary
 * Ponto de entrada para exportação de utilitários de formatação e parsing.
 * Agrupa exportações de `fmt`, `tipos` e `utils` para uso centralizado.
 *
 * @example
 * ```ts
 * import { fmt, parse, cn, FormatOptions } from "@nucleo/servicos/formatadores";
 *
 * const dataFormatada = fmt.dates.BR("20250528");
 * const erroProtheus = parse.protheus.error("erro log");
 * ```
 */

export * from "./fmt";
export * from "./types";
export * from "./utils";
